/**
 *
 * BoxMeasurementResponse
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
import { get } from "lodash"
import starIcon from "../../images/star.svg"
import warningIcon from "../../images/warning.svg"
import "./index.less"

/* eslint-disable react/prefer-stateless-function */
class BoxMeasurementResponse extends React.Component {
  render() {
    const { data } = this.props

    return (
      <div className="box-measurement-response">
        <div>
          <span className="subtitle_section">
            <img src={starIcon} /> Mejor dimensión
          </span>
          <div className="box-measurement-response-result">
            {get(data, "dimensions_top[0].dimension_name", "")}
            <span
              style={{
                backgroundColor: get(
                  data,
                  "dimensions_top[0].color",
                  "#EA6364"
                ),
              }}>
              {get(data, "dimensions_top[0].value_visible", "0%")}
            </span>
          </div>
        </div>
        <div>
          <span className="subtitle_section">
            <img src={warningIcon} /> Mayor oportunidad de mejora
          </span>
          <div className="box-measurement-response-result">
            {get(data, "dimensions_bottom[0].dimension_name", "")}
            <span
              style={{
                backgroundColor: get(
                  data,
                  "dimensions_bottom[0].color",
                  "#EA6364"
                ),
              }}>
              {get(data, "dimensions_bottom[0].value_visible", "0%")}
            </span>
          </div>
        </div>
      </div>
    )
  }
}

BoxMeasurementResponse.propTypes = {}

export default BoxMeasurementResponse
